import api from 'common/api';
import {
  SearchEntityMasterRequest,
  DetailEntityMasterRequest,
  UpdateEntityMasterRequest,
  DeleteEntityMasterRequest,
} from 'api-types/src/types/entity-master';

export const getAccountAPI = (params: SearchEntityMasterRequest) => api.get('/client-mast/list', params);

export const getAccountDetailAPI = (params: DetailEntityMasterRequest) => api.get('/client-mast/detail', params);

export const addAccountAPI = (params: UpdateEntityMasterRequest) => api.post('/client-mast/add-client', params);

export const updateAccountAPI = (params: UpdateEntityMasterRequest) => api.put('/client-mast/update-client', params);

export const deleteAccountAPI = (params: DeleteEntityMasterRequest) => api.put('/client-mast/delete-client', params);

export const DOWNLOAD_ACCOUNT_EXCEL_API = '/client-mast/list';
